
import djhu from '../lib/util/djhu'

/**
 * selectRole
 */
const selectRole = function selectRole(selector, actionUrl) {
    var ROLE_SELECTED = 'role-selected',
        d = document.getElementsByClassName(ROLE_SELECTED),
        target = document.querySelector(selector)

    if (!target) {
        return
    }
        
    if (d.length > 0) {
        d[0].className = ''
    }

    target.className += ROLE_SELECTED 
    document.getElementById('loginForm').setAttribute('action', actionUrl)
    document.querySelector('[name="email"]').focus()
}

// document.addEventListener('DOMContentLoaded', () => {
djhu(document).ready(() => {
    var loginDialog = djhu('#login-dlg'),
        loginForm = document.getElementById('loginForm'),
        selectDesigner = function selectDesigner() {
            selectRole('#designerRole', loginForm.dataset.designer)
        },
        selectGuest = function selectGuest() {
            selectRole('#guestRole', loginForm.dataset.guest)
        },
        hide = function hide() {
            loginDialog.hide()
        }

    if (!loginDialog || !loginForm) {
        return
    }

    djhu('#loginButton').click(() => {
        loginDialog.show()
        document.querySelector('[name="email"]').focus()
    })

    djhu('#designerRole').click(() => {
        selectDesigner()
    })

    djhu('#guestRole').click(() => {
        selectGuest()
    })

    djhu('#hideLoginFormButton').click(() => {
        hide()
    })

    selectDesigner()
    hide()
})



// WEBPACK FOOTER //
// ./resources/assets/js/components/login-form.js